/* @ngInject */
const sortOptions = (
  utils,
  types,
  excelStyles,
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'scrapping'
    options.enableColor = true
    options.enableOwnerSheet = false
    options.firstRow = 4
    options.getBodyCells = self.getBodyCells
    options.style = excelStyles.bodyCell()

    return options
  }

  self.getBodyCells = ({ currentRow, }, wagon,) => {
    return [{
      name: 'A' + currentRow,
      ref: 'id',
      value: wagon.id,
      type: types.wagonId,
    }, {
      name: 'B' + currentRow,
      ref: 'owner',
      value: wagon.owner,
    }, {
      name: 'C' + currentRow,
      ref: 'typeAndSet',
      value: wagon.typeAndSet,
    }, {
      name: 'D' + currentRow,
      ref: 'railway',
      value: wagon.railway,
    }, {
      name: 'E' + currentRow,
      ref: 'ratioPosition',
      value: wagon.ratioPosition,
    }, {
      name: 'F' + currentRow,
      ref: 'completeRevisionExcel',
      value: wagon.completeRevisionExcel,
    }, {
      name: 'G' + currentRow,
      ref: 'length',
      value: wagon.length,
      type: types.decimal,
    }, {
      name: 'H' + currentRow,
      ref: 'tare',
      value: wagon.tare,
      type: types.decimal,
    }, {
      name: 'I' + currentRow,
      ref: 'case',
      value: wagon.case,
    }, {
      name: 'J' + currentRow,
      ref: 'sale',
      value: wagon.sale,
    }, {
      name: 'K' + currentRow,
      ref: 'raadRaat',
      value: wagon.raadRaat,
    }]
  }

  return self
}
export default sortOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/wagon/scrappingOptions.ressource.js